import { PageHeader } from "@/components/common";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Lightbulb } from "@/lib/icons";

export default function Create() {
  return (
    <div className="max-w-3xl mx-auto">
      <PageHeader eyebrow="Curate" color="#A855F7" title="Curate"
        subtitle="Review, enrich, and prepare captured material for continued use." />
      <div className="dl-card p-8 text-center">
        <div className="h-14 w-14 rounded-2xl grid place-items-center mx-auto mb-4" style={{ background: "#A855F722", color: "#A855F7" }}><Lightbulb size={26} /></div>
        <h3 className="font-display text-lg text-white">Editorial workbench — planned for Stage 2</h3>
        <p className="text-sm text-slate-400 mt-2 max-w-md mx-auto">
          Stage 1 curation already includes reviewing items in Collect, editing capture details, and connecting related people, places, and collections. Stage 2 adds composed drafts from selected captures, preserved citations, autosave, revision history, and export.
        </p>
        <div className="flex flex-wrap justify-center gap-2 mt-5">
          <Button asChild variant="outline"><Link to="/collect">Review collected items</Link></Button>
          <Button asChild variant="outline"><Link to="/catalog">Browse the catalog</Link></Button>
        </div>
        <p className="text-xs text-slate-500 mt-4">Draft composition is planned; it is not presented as a working feature yet.</p>
      </div>
    </div>
  );
}
